import { Context, FC } from 'react';

export function createProviderFromContext<TProps>(context: Context<TProps>) {
  const Provider: FC<TProps> = ({ children, ...rest }) => (
    <context.Provider value={rest as any}>{children}</context.Provider>
  );
  return Provider;
}
